import CHUBBPricesPerPasseger from './chubb-prices-per-passenger';

class CHUBBPricesUIModel {
  constructor({
    currencyPerPassengerArray = undefined,
    isChubbPrice = false,
    type = '',
  } = {}) {
    if (currencyPerPassengerArray) {
      this.currencyPerPassengerArray = currencyPerPassengerArray.map(currencyPerPassenger => {
        return new CHUBBPricesPerPasseger(currencyPerPassenger);
      });
    }

    this.isChubbPrice = isChubbPrice;
    this.type = type;
  }
}

export default CHUBBPricesUIModel;
